import React from 'react';
import { Layers, ArrowLeft } from 'lucide-react';
import { LAW_CONFIG } from '../../data/laws'; 

export default function StageSelectView({ setView, setSelectedStage, selectedLaw }) {
  const config = LAW_CONFIG[selectedLaw];
  const stages = config?.stages || [];
  const lawData = config?.data || [];

  return (
    <div className="space-y-6 animate-fadeIn">
      {/* 상단 헤더 */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-white flex items-center">
          <Layers className="mr-2 text-indigo-400" /> {selectedLaw} 단계 선택
        </h2>
        <button 
          onClick={() => setView('home')} 
          className="bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg font-bold flex items-center transition"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> 뒤로가기
        </button>
      </div>

      {/* 단계 선택 그리드 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {stages.map((stage) => {
          const isLastStage = stage.id === config.maxStage;
          
          // 해당 단계의 문항 수 계산
          const stageQuestions = isLastStage 
            ? 30 
            : lawData.filter(q => q.stage === stage.id).length;

          // [로직] stage.desc에서 주제와 범위 분리
          let titlePart = stage.desc;
          let rangePart = "";
          
          // 괄호로 묶인 부분((...))을 찾아서 분리합니다.
          const rangeMatch = stage.desc.match(/\(.*\)/); 
          if (rangeMatch) {
              rangePart = rangeMatch[0]; // 예: "(제1조~제8조)"
              titlePart = stage.desc.replace(rangePart, "").trim(); // 예: "총칙"
          }

          return (
            <button 
              key={stage.id} 
              onClick={() => { 
                setSelectedStage(stage.id); 
                setView('game'); 
              }} 
              // [디자인] items-start로 설정하여 뱃지/제목/문항수가 위쪽 라인에 맞춰 정렬됨
              className={`group w-full bg-slate-800 hover:bg-slate-750 border border-slate-700 hover:border-indigo-500 p-4 rounded-xl shadow-lg transition-all flex flex-row items-start text-left ${
                isLastStage ? 'md:col-span-2 border-indigo-500/50 bg-indigo-900/20' : ''
              }`}
            >
                {/* 1. 단계 뱃지 */}
                <span className="bg-indigo-600 text-white text-xs font-bold px-2 py-1 rounded shrink-0 mr-3 mt-0.5">
                  {stage.title}
                </span>

                {/* 2. 제목 및 범위 컨테이너 (세로 배치) */}
                <div className="flex flex-col flex-1 mr-2 overflow-hidden">
                    {/* 윗줄: 주제 (글자 크기 작게: text-sm) */}
                    <span className="text-slate-200 font-bold text-sm truncate">
                      {titlePart}
                    </span>
                    
                    {/* 아랫줄: 범위 (더 작게, 연하게: text-xs) */}
                    {rangePart && (
                        <span className="text-slate-400 font-medium text-xs truncate mt-0.5">
                          {rangePart}
                        </span>
                    )}
                </div>

                {/* 3. 문항 수 */}
                <span className="text-slate-500 text-sm font-medium shrink-0 mt-0.5">
                  {stageQuestions}문항
                </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}